<template>
  <div>
    <transition name="fade" :key="2">
      <div
        :key="'compact_selector_dark'"
        class="pu_dark"
        v-show="$store.getters.modal.callWaiter"
      ></div>
    </transition>
    <!-- <transition name="fade"> -->
      <div
        v-show="$store.getters.modal.callWaiter"
        class="callwaiter_modal pu_bottom popup_click_hide"
      >
        <div class="pu_bottom_scroll">
          <div class="pu_b_close cross" @click="close()"></div>

          <div v-if="success" class="pu_bottom_inner scroll_y" v-html="text('message_calling_the_waiter_successfully_sent')">
          </div>

          <div v-else class="pu_bottom_inner scroll_y">
  
            <!-- <div v-if="text('basket_enter_promo_code')" class="pu_tovar_name callwaiter_modal_title">
                        {{text('basket_enter_promo_code')}}
                        </div> -->
            <!-- :filled="focused || (promocode !== null && promocode !== '')" -->
            <div v-for="(r, ind) in reasons()" :key="ind" 
              class="call_reason" :class="{selected: ind===reasonInd}"
              @click="reasonInd=ind"
            >
              {{r}}
            </div>

            <text-input
              v-if="$store.getters.showCallingWaiterComment"
              ref="callWaiterComment"
              :filled="focused || (comment !== null && comment !== '')"
              :field="'comment'"
              :label="text('message_calling_the_waiter_comment')"
              :value.sync="comment"
              class="comment-input"
              @focus="focused=true"
              @unfocus="focused=false"            
            />
            <div class="pu_tovar_nav_btn">
              <a class="callwaiter_send_btn fbb_btn" @click="callWaiter()">
                {{ text("button_calling_the_waiter_send") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    <!-- </transition> -->
  </div>
</template>
  
<script>
import "@/assets/css/slick.css";
import { SET_MODAL } from "@/store/mutations.type";
import { CALL_WAITER } from "@/store/actions.type";
import TextInput from '@/components/Default/Input/TextInput'

export default {
  name: "TopBar",
  components: {
    TextInput
  },
  data() {
    return {
      callWaiterError: false,
      comment: "",
      reasonInd: 0,
      focused: false,
      success: false,
      reasons() {
        return [
          this.text('button_calling_the_waiter_action_call'),
          this.text('button_calling_the_waiter_action_invoice_cash'),
          this.text('button_calling_the_waiter_action_invoice_card'),
        ]
       }
    };
  },
  watch: {
    modalCallWaiter() {
      this.success = false;
    },
  },
  computed: {
    modalCallWaiter() {
      return this.$store.getters.modal.callWaiter;
    }
  },
  methods: {
    close() {
      this.$store.commit(SET_MODAL, { modal: "callWaiter", status: false });
      let element = document.getElementById("topBar");
      if (element) {
          element.classList.remove("collapsed");
      }
    },
    async callWaiter() {
      let comment = this.reasons()[this.reasonInd] 
      if (this.comment) 
        comment += `. ${this.text('message_calling_the_waiter_comment')}: ${this.comment}`
      this.$store.dispatch(CALL_WAITER, {comment}).then(data => {
        if (data.message === "Success")  {
          this.success = true
        }
      })
    },
  },
};
</script>
  
<style scoped>
.callwaiter_modal {
  top: 100px !important;
  align-items: flex-start !important;
  width: calc(100% - 32px) !important;
  margin: 0 16px;
}

.callwaiter_modal .pu_bottom_inner {
  padding: 40px 20px;
  box-sizing: border-box;
  border-radius: 15px;
}

.callwaiter_modal .callwaiter_send_btn {
  margin: 40px auto 0 auto;
}

.callwaiter_modal .comment-input {
  margin: 10px 10px 20px 10px;
}

.call_reason {
  border-radius: 10px;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: #999999;
  padding: 8px 16px;
  margin: 8px 0;
  width: 100%;
  box-sizing: border-box;
  transition: 0.2s all ease;
  cursor: pointer;
}

.call_reason.selected {
  background: #EAF5FE;
  color: #0084FF;
}

</style>
